import type { BuildOperationInput, BuildOperationResult } from "./operation.ts";
import detailFilterOperationV2 from "./detail-filter-operation-v2.ts";

function* detailFilterOperation(
	input: BuildOperationInput,
): Generator<undefined, BuildOperationResult> {
	const { config } = input;

	const { detailFilter } = config;
	if (!detailFilter) {
		return { type: "no-change" };
	}

	return yield* detailFilterOperationV2(input);
}

export default detailFilterOperation;
